import React, { Fragment } from "react";

import Button from "react-bootstrap/Button";

import { SearchBarNew } from "../SearchBarNew";

export default function Search({ isLoading, setQuery, handleSearch }) {
  return (
    <>
      <SearchBarNew
        onQueryChange={setQuery}
        placeholder="Search by email, name, or organization"
        size="md"
      ></SearchBarNew>
      <Button
        type="submit"
        size="lg"
        disabled={isLoading}
        onClick={handleSearch}
      >
        Search
      </Button>
    </>
  );
}
